module.exports = {"410202001":"北书店街道","410202002":"午朝门街道","410202003":"大兴街道","410202005":"北道门街道","410202201":"北郊乡","410202202":"柳园口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410202.json
// module id = 1401
// module chunks = 0